import React from "react";
import ReactDOM from "react-dom";
import http from '../modules/api';
import BasicDialogV2 from "../modules/dialogs/BasicDialogV2";
import PopupFrameV2 from '../modules/popup/PopupFrameV2';
import WarningDialog from '../modules/dialogs/WarningDialog';
import CheckBox from "../modules/common/CheckBox";

import TitleContentDialogV2 from "../modules/dialogs/TitleContentDialogV2";

const FACEBOOK_APP_ID = '780456611206591';
const BASEDOMAIN = document.domain.indexOf("127.0.0.1") >= 0 ? 'https://127.0.0.1:8092' : window.location.origin;
const REDIRECT_URI = BASEDOMAIN + '/rest/shop/instagram/callback';
const SCOPES = [
  'pages_show_list',
  // 'pages_read_engagement',
  'business_management',
  'instagram_basic',
  'instagram_content_publish',
  'instagram_manage_contents',
  'instagram_manage_insights',
  // 'catalog_management',
  // 'instagram_shopping_tag_products',
  'public_profile'
].join(',');

const FACEBOOK_OAUTH_RETURN_STATE_PREFIX = "robomd_return:";

const getFacebookOAuthReturnPath = () => {
  try {
    const url = new URL(window.location.href);
    url.searchParams.delete("facebook_oauth_status");
    url.searchParams.delete("facebook_oauth_token_id");
    return `${url.pathname}${url.search}`;
  } catch (e) {
    return window.location.pathname || "/shop/instagram/InstagramAccountManager";
  }
};

const isMobileFacebookOAuth = () => {
  try {
    const userAgent = navigator.userAgent || "";
    const isMobileUserAgent = /Android|iPhone|iPad|iPod|Mobile/i.test(userAgent);
    const isIPadOS = navigator.platform === "MacIntel" && navigator.maxTouchPoints > 1;
    return isMobileUserAgent || isIPadOS;
  } catch (e) {
    return false;
  }
};

/**
 * Android 브라우저에서 facebook.com 링크가 Facebook 앱으로 App Link 처리되는 것을
 * 최대한 피하기 위해 링크 이동/window.open 대신 현재 탭의 GET form submit으로 OAuth를 시작한다.
 */
const submitFacebookOAuthForm = ({ redirectUri, returnPath = "" } = {}) => {
  const form = document.createElement("form");
  form.method = "GET";
  form.action = "https://www.facebook.com/v24.0/dialog/oauth";
  form.target = "_self";
  form.style.display = "none";

  const oauthParams = {
    client_id: FACEBOOK_APP_ID,
    redirect_uri: redirectUri,
    scope: SCOPES,
    response_type: "code",
  };

  // 모바일에서는 reauthenticate가 Facebook 앱 전환을 유발할 수 있어 제외한다.
  // PC에서는 기존 동작대로 재로그인을 유도한다.
  if (!isMobileFacebookOAuth()) {
    oauthParams.auth_type = "reauthenticate";
  }


  if (returnPath) {
    oauthParams.state = FACEBOOK_OAUTH_RETURN_STATE_PREFIX + encodeURIComponent(returnPath);
  }

  Object.entries(oauthParams).forEach(([name, value]) => {
    const input = document.createElement("input");
    input.type = "hidden";
    input.name = name;
    input.value = value;
    form.appendChild(input);
  });

  document.body.appendChild(form);
  form.submit();
};

const params = new URLSearchParams(window.location.search);

export default class InstagramAccountManager extends React.Component {

  constructor(props) {
    super(props);
    this.state = {
      status: params.get("status") || "",
      token_id: params.get("token_id") || "",
      required_permission: params.get("required_permission") || "",
      selected_account_list : [],
      add_account_list: [],

      isConnected: props.isConnected ?? false,
      currentService: "",
      currentFacebookTokenId: "",
      showDisconnectModal: false,
      showFacebookDisconnectModal: false,

      account_list: [],

      // 계정별 토큰 헬스 상태 (token_id -> { status, message, need_user_login, reauthorize_url, missing_permissions_ko, token_info })
      healthByTokenId: {},

      /* BasicDialog 변수 */
      basic_dialog_show_state: false,
      basic_dialog_content: "",
      basic_dialog_button_list: [{title:"확인", event_method:()=>{this.setState({basic_dialog_show_state:false})}}],

      // show_account_connect_popup: true,

      title_content_dialog_title: "",
      title_content_dialog_content: "",
      title_content_dialog_button_list: [{title:"확인", event_method:()=>{this.setState({title_content_dialog_show_state:false})}}],
      title_content_dialog_show_state: false,

    };
  }

  componentDidMount() {
    // alert("status : " + this.state.status + ", token_id : " + this.state.token_id);
    if (this.state.status == "success") {
      if (this.state.token_id) {
        // alert("token_id : " + this.state.token_id);
        this.loadInstagramAccountList(this.state.token_id);
        this.setState({
          show_account_connect_popup: true
        })
      }
    }
    // else {
      this.loadInstagramAccountList();
      this.getRpStatus();

      if (this.state.required_permission === "instagram_manage_contents") {
        this.setState({
          basic_dialog_show_state: true,
          basic_dialog_content: "인스타그램에 발행된 콘텐츠를 삭제하려면 삭제 권한이 필요합니다.<br/>재연동을 통해 권한을 승인해주세요.",
          basic_dialog_button_list: [
            {
              title: "재연동",
              event_method: () => {
                this.setState({ basic_dialog_show_state: false }, () => {
                  this.handleConnectAccount();
                });
              }
            }
          ]
        });
      }
    // }
  }

  /* =========================
   *  Facebook OAuth Connect
   * ========================= */
  handleConnect = async () => {
    
    const result = await this.openConfirmDialog({
      title: "인스타그램 계정 추가를 위해<br/>페이스북 로그인 페이지로 이동하시겠습니까?",
      content: "",
    });

    if (!result) {
      return;
    }

    submitFacebookOAuthForm({
      redirectUri: REDIRECT_URI,
    });
  };

  handleConnectAccount = async () => {
    const result = await this.openConfirmDialog({
      title: "인스타그램 계정 연동을 위해<br/>페이스북 로그인 페이지로 이동하시겠습니까?",
      content: "",
    });

    if (!result) {
      return;
    }

    submitFacebookOAuthForm({
      redirectUri: REDIRECT_URI,
    });
  };

  /* =========================
   *  Modal Controls
   * ========================= */
  openModal = (service) => {
    this.setState({ currentService: service, showDisconnectModal: true });
  };

  closeModal = () => {
    this.setState({ showDisconnectModal: false });
  };

  disconnect = () => {
    // alert(this.state.currentService + " 연결이 해제되었습니다.");
    this.setState({
      basic_dialog_show_state: true,
      basic_dialog_content: "연결이 해제되었습니다.",
    });
    this.closeModal();
  };

  openFacebookModal = (token_id, name) => {
    this.setState({
      currentfacebookAccountName: name,
      currentFacebookTokenId: token_id,
      showFacebookDisconnectModal: true,
    });
  };

  closeFacebookModal = () => {
    this.setState({
      currentfacebookAccountName: "",
      currentFacebookTokenId: "",
      showFacebookDisconnectModal: false,
    });
  };

  toggleConnection = () => {
    this.setState((s) => ({ isConnected: !s.isConnected }));
  };

  /* =========================
   *  API Calls
   * ========================= */
  loadInstagramAccountList(token_id) {
    if (token_id) {
      http.get("/rest/shop/instagram/profile/list?token_id=" + token_id)
        .then(res => {
          if (res.data.list != null) {
            this.setState({
              add_account_list: res.data.list,
            });
          }
        }).catch(error => {
          console.log(error);
        })
    }
    else {
      http.get("/rest/shop/instagram/profile/list")
        .then(res => {
          if (res.data.list != null) {
            this.setState({
              account_list: res.data.list,
              isConnected: res.data.list.length > 0 ? true : false
            }, () => {
              // 계정별 토큰 헬스 검사
              this.state.account_list.forEach(acc => this.checkFacebookTokenStatusForAccount(acc));
            });
          }
        }).catch(error => {
          console.log(error);
        })
    }
  }

  updateAccountsUseYn = (token_id, selected_account_list, use_yn) => {
    return http.post(
      "/rest/shop/instagram/updateAccountsUseYn",
      { token_id, selected_account_list, use_yn },
      {
        headers: {
          "Content-Type": "application/json",
          "Accept": "application/json",
        },
      }
    );
  };

  updateSelectedAccountsUseYn = () => {
    const { token_id, selected_account_list } = this.state;

    if (!token_id) {
      this.setState({
        warning_dialog_show_state: true,
        warning_dialog_content: "토큰 정보가 없습니다. 다시 연동해주세요."
      });
      return;
    }

    if (!selected_account_list || selected_account_list.length === 0) {
      this.setState({
        warning_dialog_show_state: true,
        warning_dialog_content: "하나 이상의 계정을 선택 해 주세요."
      });
      return;
    }

    this.updateAccountsUseYn(token_id, selected_account_list, "Y")
      .then((res) => {
        const data = res && res.data ? res.data : {};
        if (String(data.code) === "200") {
          console.log("SUCCESS cnt:", data.cnt);
          window.location.href = "/shop/instagram/InstagramAccountManager";
        } else {
          console.log("FAIL:", data);
          this.setState({
            warning_dialog_show_state: true,
            warning_dialog_content: "계정 업데이트에 실패했습니다."
          });
        }
      })
      .catch((err) => {
        console.error("ERROR:", err);
        this.setState({
          warning_dialog_show_state: true,
          warning_dialog_content: "서버 요청 중 오류가 발생했습니다."
        });
      });
  };

  // 계정별 Facebook 토큰 상태 검사 + 자동 갱신 시도
  checkFacebookTokenStatusForAccount = async (account) => {
    console.log("[checkFacebookTokenStatusForAccount] account:", account);
    const token_id = account.token_id;
    console.log("[checkFacebookTokenStatusForAccount] token_id:", token_id);
    try {
        if (!token_id) {
          console.warn("[checkFacebookTokenStatusForAccount] missing token_id for account:", account);
          return;
        }
  
        // 서버에 instagram_access_token_seq 전달
        const resp = await http.get("/rest/shop/instagram/check-token-permissions", {
          params: { token_id: token_id }
        });
  
        const data = resp?.data || {};
        this.setState(prev => ({
          healthByTokenId: {
            ...prev.healthByTokenId,
            [token_id]: {
              status: data.status || "UNKNOWN",
              message: data.message || "",
              need_user_login: !!data.need_user_login,
              reauthorize_url: data.reauthorize_url,
              service_available: data.service_available !== false,
              reauthorization_required: !!data.reauthorization_required,
              limited_features: data.limited_features || [],
              missing_permissions_en: data.missing_permissions_en || [],
              missing_permissions_ko: data.missing_permissions_ko || [],
              token_info: data.token_info || {},
            }
          }
        }));
    } catch (e) {
      console.error("[checkFacebookTokenStatusForAccount] error:", e);
      this.setState(prev => ({
        healthByTokenId: {
          ...prev.healthByTokenId,
          [token_id]: {
            status: "ERROR",
            message: e?.message || "토큰 검사 중 오류가 발생했습니다.",
            need_user_login: true
          }
        }
      }));
    }
  };

  disconnectAllPermissions(token_id) {
    http.post("/rest/shop/instagram/disconnect/allPermissions?token_id=" + token_id)
      .then(res => {
        // alert("페이스북 계정 연결이 해제되었습니다.");
        this.setState({
          basic_dialog_show_state: true,
          basic_dialog_content: "페이스북 계정 연결이 해제되었습니다.",
        });
        this.setState({
          currentfacebookAccountName: "",
          currentFacebookTokenId: "",
          showFacebookDisconnectModal: false,
        });
        this.loadInstagramAccountList();
      }).catch(error => {
        console.log(error);
      })
  }

  setDefaultInstagram(instagram_access_token_seq) {
    http.post("/rest/shop/instagram/default?instagram_access_token_seq=" + instagram_access_token_seq)
      .then(res => {
        // alert("기본으로 설정 되었습니다.");
        this.setState({
          basic_dialog_show_state: true,
          basic_dialog_content: "기본으로 설정 되었습니다.",
        });
        this.setState({
          currentfacebookAccountName: "",
          currentFacebookTokenId: "",
          showFacebookDisconnectModal: false,
        });
        this.loadInstagramAccountList();
      }).catch(error => {
        console.log(error);
      })
  }

  getRpStatus() {
    http.get("/rest/shop/instagram/rp/status")
      .then(res => {
        const data = res.data;
        this.setState({
          rp_added_type: data.added_type,
          rp_is_finish: data.is_finish,
          rp_payment_yn: data.payment_yn,
        });
      }).catch(error => {
        console.log(error);
      })
  }

  goRpService() {
    http.get("/rest/common/changeServiceType?service_type=01002")
      .then(res => {
        const data = res.data;
        window.location.href = data.redirectUrl;
      }).catch(error => {
        console.log(error);
      })
  }

  /* =========================
   *  Renders
   * ========================= */
  renderNotConnected() {
    return (
      <div className="instagram_account_page">
        <div className="container">
          <h1 className="page-title">계정 관리</h1>
          <p className="page-subtitle">페이스북 계정을 연결하고 인스타그램 계정을 관리합니다</p>
          <div className="section">
            <div className="section-header">
              <h2 className="section-title">소셜미디어 계정</h2>
              <button className="btn btn-add" onClick={this.handleConnect}><span>+</span> 인스타그램 계정 추가</button>
            </div>
            <div className="empty-card">
              <div className="empty-icon"><i className="fa fa-brands fa-instagram"></i></div>
              <div className="empty-title">연결된 소셜미디어 계정이 없습니다</div>
              <div className="empty-text">페이스북을 통해 인스타그램 비즈니스 계정을 연결하여<br />피드를 자동으로 관리하세요</div>
              <button className="btn btn-add" onClick={this.handleConnect}><span>+</span> 인스타그램 계정 추가</button>
            </div>
          </div>

          {/* API 연동 섹션 */}
          {
            sessionStorage.getItem("roleType") != "2221" && (
              <div className="section">
                <h2 className="section-title solo">API 연동</h2>
                <div className="api-grid">
                  <div className="api-card">
                    {
                      this.state.rp_added_type != "Y" ? (
                        <div className="api-status status-inactive" />
                      ) :
                        this.state.rp_is_finish == 1
                          ? (<div className="api-status status-inactive" />)
                          : (<div className="api-status status-active" />)
                    }
                    <div className="api-icon-wrapper">
                      <div className="api-icon">
                        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <g clip-path="url(#clip0_2434_305)">
                          <path d="M9.79828 2.34113H4.21878C3.64599 2.34113 3.18164 2.81822 3.18164 3.40674V7.99969C3.18164 8.58821 3.64599 9.0653 4.21878 9.0653H9.79828C10.3711 9.0653 10.8354 8.58821 10.8354 7.99969V3.40674C10.8354 2.81822 10.3711 2.34113 9.79828 2.34113Z" fill=""/>
                          <path d="M9.79826 2.96796C10.0312 2.96796 10.2253 3.1674 10.2253 3.40674V7.99969C10.2253 8.23903 10.0312 8.43847 9.79826 8.43847H4.21876C3.98582 8.43847 3.7917 8.23903 3.7917 7.99969V3.40674C3.7917 3.1674 3.98582 2.96796 4.21876 2.96796H9.79826ZM9.79826 1.71429H4.21876C3.30918 1.71429 2.57153 2.47219 2.57153 3.40674V7.99969C2.57153 8.93424 3.30918 9.69213 4.21876 9.69213H9.79826C10.7078 9.69213 11.4455 8.93424 11.4455 7.99969V3.40674C11.4455 2.47219 10.7078 1.71429 9.79826 1.71429Z" fill="#1D1D1B"/>
                          <path d="M10.8409 11.4587H3.17607C2.8433 11.4587 2.57153 11.1795 2.57153 10.8318C2.57153 10.4842 2.8433 10.205 3.17607 10.205H10.8465C11.1793 10.205 11.451 10.4842 11.451 10.8318C11.451 11.1795 11.1793 11.4587 10.8465 11.4587H10.8409Z" fill="#1D1D1B"/>
                          <path d="M19.7814 2.34113H14.2019C13.6291 2.34113 13.1648 2.81822 13.1648 3.40674V7.99969C13.1648 8.58821 13.6291 9.0653 14.2019 9.0653H19.7814C20.3542 9.0653 20.8186 8.58821 20.8186 7.99969V3.40674C20.8186 2.81822 20.3542 2.34113 19.7814 2.34113Z" fill=""/>
                          <path d="M19.7814 2.96796C20.0144 2.96796 20.2085 3.1674 20.2085 3.40674V7.99969C20.2085 8.23903 20.0144 8.43847 19.7814 8.43847H14.2019C13.969 8.43847 13.7749 8.23903 13.7749 7.99969V3.40674C13.7749 3.1674 13.969 2.96796 14.2019 2.96796H19.7814ZM19.7814 1.71429H14.2019C13.2923 1.71429 12.5547 2.47219 12.5547 3.40674V7.99969C12.5547 8.93424 13.2923 9.69213 14.2019 9.69213H19.7814C20.691 9.69213 21.4286 8.93424 21.4286 7.99969V3.40674C21.4286 2.47219 20.691 1.71429 19.7814 1.71429Z" fill="#1D1D1B"/>
                          <path d="M20.824 11.4587H13.1536C12.8208 11.4587 12.5491 11.1795 12.5491 10.8318C12.5491 10.4842 12.8208 10.205 13.1536 10.205H20.824C21.1568 10.205 21.4286 10.4842 21.4286 10.8318C21.4286 11.1795 21.1568 11.4587 20.824 11.4587Z" fill="#1D1D1B"/>
                          <path d="M9.79828 13.1682H4.21878C3.64599 13.1682 3.18164 13.6453 3.18164 14.2338V18.8268C3.18164 19.4153 3.64599 19.8924 4.21878 19.8924H9.79828C10.3711 19.8924 10.8354 19.4153 10.8354 18.8268V14.2338C10.8354 13.6453 10.3711 13.1682 9.79828 13.1682Z" fill=""/>
                          <path d="M9.79826 13.795C10.0312 13.795 10.2253 13.9945 10.2253 14.2338V18.8268C10.2253 19.0661 10.0312 19.2656 9.79826 19.2656H4.21876C3.98582 19.2656 3.7917 19.0661 3.7917 18.8268V14.2338C3.7917 13.9945 3.98582 13.795 4.21876 13.795H9.79826ZM9.79826 12.5414H4.21876C3.30918 12.5414 2.57153 13.2993 2.57153 14.2338V18.8268C2.57153 19.7613 3.30918 20.5192 4.21876 20.5192H9.79826C10.7078 20.5192 11.4455 19.7613 11.4455 18.8268V14.2338C11.4455 13.2993 10.7078 12.5414 9.79826 12.5414Z" fill="#1D1D1B"/>
                          <path d="M10.8409 22.2858H3.17607C2.8433 22.2858 2.57153 22.0065 2.57153 21.6589C2.57153 21.3113 2.8433 21.0321 3.17607 21.0321H10.8465C11.1793 21.0321 11.451 21.3113 11.451 21.6589C11.451 22.0065 11.1793 22.2858 10.8465 22.2858H10.8409Z" fill="#1D1D1B"/>
                          <path d="M19.7814 13.1682H14.2019C13.6291 13.1682 13.1648 13.6453 13.1648 14.2338V18.8268C13.1648 19.4153 13.6291 19.8924 14.2019 19.8924H19.7814C20.3542 19.8924 20.8186 19.4153 20.8186 18.8268V14.2338C20.8186 13.6453 20.3542 13.1682 19.7814 13.1682Z" fill=""/>
                          <path d="M19.7814 13.795C20.0144 13.795 20.2085 13.9945 20.2085 14.2338V18.8268C20.2085 19.0661 20.0144 19.2656 19.7814 19.2656H14.2019C13.969 19.2656 13.7749 19.0661 13.7749 18.8268V14.2338C13.7749 13.9945 13.969 13.795 14.2019 13.795H19.7814ZM19.7814 12.5414H14.2019C13.2923 12.5414 12.5547 13.2993 12.5547 14.2338V18.8268C12.5547 19.7613 13.2923 20.5192 14.2019 20.5192H19.7814C20.691 20.5192 21.4286 19.7613 21.4286 18.8268V14.2338C21.4286 13.2993 20.691 12.5414 19.7814 12.5414Z" fill="#1D1D1B"/>
                          <path d="M20.824 22.2858H13.1536C12.8208 22.2858 12.5491 22.0065 12.5491 21.6589C12.5491 21.3113 12.8208 21.0321 13.1536 21.0321H20.824C21.1568 21.0321 21.4286 21.3113 21.4286 21.6589C21.4286 22.0065 21.1568 22.2858 20.824 22.2858Z" fill="#1D1D1B"/>
                          </g>
                          <defs>
                          <clipPath id="clip0_2434_305">
                          <rect width="18.8571" height="20.5714" fill="white" transform="translate(2.57153 1.71429)"/>
                          </clipPath>
                          </defs>
                        </svg>
                      </div>
                    </div>
                    <div className="api-title">로보MD 진열</div>
                    <div className="api-description">AI 기반 상품 추천 및 자동 피드 생성</div>
                    <div className="api-info">
                      <div className="info-item">
                        <div className="info-label">상태</div>
                      </div>
                      <div className="info-item right">
                        <div className="info-value">
                          {
                            this.state.rp_added_type != "Y" ? (
                              <div className="info-value inactive">미연동</div>
                            ) :
                              this.state.rp_is_finish == 1
                                ? (<div className="info-value inactive">기간 만료</div>)
                                : (<div className="info-value">연결됨</div>)
                          }
                        </div>
                      </div>
                    </div>
                    {
                      this.state.rp_added_type != "Y" ? (
                        <button className="btn-api btn-connect" onClick={() => this.goRpService()}>연결하기</button>
                      ) :
                        this.state.rp_is_finish == 1
                          ? (<button className="btn-api btn-connect" onClick={() => this.goRpService()}>연결하기</button>)
                          : (<button className="btn-api btn-connect" onClick={() => this.goRpService()}>진열 바로가기</button>)
                    }
                  </div>
                </div>
              </div>
            )
          }

          {/* 가이드 */}
          <div className="guide-box">
            <div className="guide-title">
              <span className="guide-icon">
                {/* 💡 */}
                <i className="fa fa-lightbulb-o"></i>
              </span>
              < span>시작하기 가이드</span>
            </div>
            <ul className="guide-list">
              <li>페이스북을 통해 인스타그램 비즈니스 계정을 먼저 연결해주세요.
                <span className="hover-underline" style={{ marginLeft: 5, cursor: "pointer", fontWeight: 600, color: "#05dbe2" }}
                title="새창으로 열기"
                onClick={() => {
                  window.open(
                    "https://robomdguide.notion.site/instagram-account",
                    "_blank"
                  );
                }}>{"[계정 연결 전 준비사항 보기]"}</span>
              </li>
              { sessionStorage.getItem("roleType") != "2221" && (
                <>
                  <li>카페24를 연결하면, 상품 정보가 자동으로 동기화됩니다.</li>
                  <li>로보MD 진열을 연결하면, 진열에 등록한 알고리즘이 자동으로 동기화됩니다.</li>
                </>
              )}
              <li>로보MD AI가 최적의 피드를 자동으로 생성해드립니다.</li>
              <li>여러 페이스북 계정을 연결하여 다수의 인스타그램 계정을 관리할 수 있습니다.</li>
            </ul>
          </div>
        </div>
      </div>
    );
  }

  renderConnected() {
    return (
      <div className="container">
        <h1 className="page-title">계정 관리</h1>
        <p className="page-subtitle">다양한 소셜미디어 계정을 연결하고 기본 계정을 관리합니다</p>

        {/* Facebook 그룹 */}
        <div className="section">
          <div className="section-header">
            <h2 className="section-title">소셜미디어 계정</h2>
            <button className="btn btn-add" onClick={this.handleConnectAccount}>+ 인스타그램 계정 추가</button>
          </div>

          {
            this.state.account_list.map((account) => {
              // 헬스 결과
              const health = this.state.healthByTokenId[account.token_id];
              const status = health?.status;
              const health_message = health?.message;
              const missingPermissionsEn = health?.missing_permissions_en || [];
              const missingPermissionsKo = health?.missing_permissions_ko || [];

              // 삭제 전용 권한만 누락된 경우 서비스 자체는 정상 이용 가능하다.
              // 백엔드/프론트 배포 시점이 어긋나도 기존 MISSING_PERMISSIONS 응답을 안전하게 처리한다.
              const isLegacyDeleteOnlyMissing =
                status === "MISSING_PERMISSIONS" &&
                missingPermissionsEn.length > 0 &&
                missingPermissionsEn.every(permission => permission === "instagram_manage_contents");

              const isLimitedPermission =
                status === "LIMITED_PERMISSIONS" ||
                isLegacyDeleteOnlyMissing;

              const isServiceUnavailable =
                (!isLimitedPermission && status === "MISSING_PERMISSIONS") ||
                status === "DATA_ACCESS_EXPIRED" ||
                (status && status.startsWith("TOKEN_INVALID"));

              const showReconnectButton = isLimitedPermission || isServiceUnavailable;

              return (
                <div className="facebook-group" key={account.token_id}>
                  <div className="facebook-header">
                    <div className="facebook-info">
                      <div className="facebook-icon">f</div>
                      <div className="facebook-details">
                        <div className="facebook-name">
                          {account.facebook_username}
                        </div>
                        <div className="facebook-status">
                          {!isServiceUnavailable ? (
                            <>
                              <div className="status-indicator status-connected"></div>
                              <span className="status-text status-connected-text">정상 연결</span>
                              {isLimitedPermission && (
                                <span className="permission-limited-badge">삭제 권한 추가 필요</span>
                              )}
                            </>
                          ) : (
                            <>
                              <div className="status-indicator status-warning"></div>
                              <span className="status-text status-warning-text">
                                {status === "DATA_ACCESS_EXPIRED" 
                                  ? "데이터 접근 만료" 
                                  : (
                                      ( missingPermissionsKo.length > 0 ? "권한 부족 / " : "" )
                                      // + (health_message &&
                                      //     (health_message + " / " )
                                      //  )
                                      + "재연동 필요" 
                                    )
                                }
                              </span>
                              {missingPermissionsKo.length > 0 && (
                                <div className="permission-list">
                                  {missingPermissionsKo.map((label, idx) => (
                                    <span key={idx} className="permission-badge">{label} 누락</span>
                                  ))}
                                </div>
                              )}
                            </>
                          )}
                        </div>
                      </div>
                    </div>
                    <div className="facebook-actions">
                      {showReconnectButton ? (
                        <button
                          className="btn btn-small btn-reconnect"
                          onClick={() => {
                            // 서버 reauthorize_url은 환경별 redirect_uri가 맞지 않을 수 있으므로
                            // 현재 도메인 기준으로 만든 프론트 OAuth URL을 사용한다.
                            this.handleConnectAccount();
                          }}
                        >
                          재연동
                        </button>
                      ) : null}
                      <button
                        className="btn btn-small btn-disconnect"
                        onClick={() => this.openFacebookModal(account.token_id, account.facebook_username)}
                      >
                        연결 해제
                      </button>
                    </div>
                  </div>

                  {/* 일부 기능 권한 안내 */}
                  {isLimitedPermission && (
                    <div className="permission-alert permission-alert-limited">
                      <span className="permission-alert-icon permission-alert-info-icon">i</span>
                      <div className="permission-alert-text">
                        {/* <strong>현재 콘텐츠 등록, 예약 발행 및 자동화 기능은 정상적으로 이용할 수 있습니다.</strong> */}
                        {/* <br /> */}
                        인스타그램에 발행된 콘텐츠를 삭제하려면 "재연동"을 통해 삭제 권한을 승인해주세요.
                      </div>
                    </div>
                  )}

                  {/* 서비스 이용에 영향을 주는 권한/만료 경고 */}
                  {isServiceUnavailable && (
                    <div className="permission-alert">
                      <span className="permission-alert-icon">⚠️</span>
                      <div className="permission-alert-text">
                        <strong>
                          {status === "DATA_ACCESS_EXPIRED"
                            ? "데이터 접근 권한이 만료되었습니다."
                            : health_message ? health_message
                              : missingPermissionsKo.length > 0 ? "필수 권한이 누락되었습니다." : "재연동 필요"}
                        </strong>
                        <br />
                        인스타그램 계정 관리를 위해 재연동이 필요합니다.
                        "재연동" 버튼을 클릭하여 권한을 다시 승인해주세요.
                      </div>
                    </div>
                  )}

                  <div className="instagram-section-header">
                    <div className="instagram-icon">
                      <img src="https://s3.ap-northeast-2.amazonaws.com/otdeal.file/instagram_logo.png" alt="instagram" />
                    </div>
                    <div className="instagram-name">연결된 인스타그램 계정</div>
                    <div className="instagram-count">{account.instagram_account_list.length}개</div>
                  </div>

                  <div className="instagram-accounts">
                    {
                      account.instagram_account_list.map((instagram) => {
                        return (
                          <div
                            className="account-card"
                            key={instagram.instagram_access_token_seq}
                            style={{ opacity: (isServiceUnavailable ? 0.5 : 1) }}
                          >
                            <div className="account-wrapper">
                              <div className="account-left">
                                <div className="account-avatar">
                                  <img src={instagram.profile_picture_url} alt="" />
                                </div>
                                <div className="account-info">
                                  <div className="account-username">
                                    {instagram.username}
                                    {instagram.default_yn === "Y" && <span className="default-badge">기본</span>}
                                  </div>
                                  <div className="account-stats">
                                    <span className="stat-item">팔로워
                                      <span className="stat-value">
                                        {
                                          instagram.total_follows_value != null
                                            ? instagram.total_follows_value < 1000
                                              ? instagram.total_follows_value
                                              : (instagram.total_follows_value / 1000).toFixed(1) + 'K'
                                            : '-'
                                        }
                                      </span>
                                    </span>
                                    <span className="stat-item">게시물 <span className="stat-value">{instagram.media_count}</span></span>
                                    <span className="stat-item">참여율
                                      <span className="stat-value">
                                        {instagram.engagement_rate != null ? instagram.engagement_rate.toFixed(1) + '%' : '-'}
                                      </span>
                                    </span>
                                  </div>
                                </div>
                              </div>
                              <div className="account-right">
                                {!isServiceUnavailable && instagram.default_yn !== "Y" ? (
                                  <button
                                    className="btn-outline"
                                    onClick={() => this.setDefaultInstagram(instagram.instagram_access_token_seq)}
                                  >
                                    기본으로 설정
                                  </button>
                                ) : (
                                  null
                                )}
                              </div>
                            </div>
                          </div>
                        )
                      })
                    }
                  </div>
                </div>
              )
            })
          }

        </div>

        {/* 타 서비스 연동 섹션 */}
        {
          sessionStorage.getItem("roleType") != "2221" && (
            <div className="section">
              <h2 className="section-title solo">서비스 연동</h2>
              <div className="api-grid">
                <div className="api-card">
                  {
                    this.state.rp_added_type != "Y" ? (
                      <div className="api-status status-inactive" />
                    ) :
                      this.state.rp_is_finish == 1
                        ? (<div className="api-status status-inactive" />)
                        : (<div className="api-status status-active" />)
                  }
                  <div className="api-icon-wrapper">
                    <div className="api-icon">
                      <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <g clip-path="url(#clip0_2434_305)">
                        <path d="M9.79828 2.34113H4.21878C3.64599 2.34113 3.18164 2.81822 3.18164 3.40674V7.99969C3.18164 8.58821 3.64599 9.0653 4.21878 9.0653H9.79828C10.3711 9.0653 10.8354 8.58821 10.8354 7.99969V3.40674C10.8354 2.81822 10.3711 2.34113 9.79828 2.34113Z" fill=""/>
                        <path d="M9.79826 2.96796C10.0312 2.96796 10.2253 3.1674 10.2253 3.40674V7.99969C10.2253 8.23903 10.0312 8.43847 9.79826 8.43847H4.21876C3.98582 8.43847 3.7917 8.23903 3.7917 7.99969V3.40674C3.7917 3.1674 3.98582 2.96796 4.21876 2.96796H9.79826ZM9.79826 1.71429H4.21876C3.30918 1.71429 2.57153 2.47219 2.57153 3.40674V7.99969C2.57153 8.93424 3.30918 9.69213 4.21876 9.69213H9.79826C10.7078 9.69213 11.4455 8.93424 11.4455 7.99969V3.40674C11.4455 2.47219 10.7078 1.71429 9.79826 1.71429Z" fill="#1D1D1B"/>
                        <path d="M10.8409 11.4587H3.17607C2.8433 11.4587 2.57153 11.1795 2.57153 10.8318C2.57153 10.4842 2.8433 10.205 3.17607 10.205H10.8465C11.1793 10.205 11.451 10.4842 11.451 10.8318C11.451 11.1795 11.1793 11.4587 10.8465 11.4587H10.8409Z" fill="#1D1D1B"/>
                        <path d="M19.7814 2.34113H14.2019C13.6291 2.34113 13.1648 2.81822 13.1648 3.40674V7.99969C13.1648 8.58821 13.6291 9.0653 14.2019 9.0653H19.7814C20.3542 9.0653 20.8186 8.58821 20.8186 7.99969V3.40674C20.8186 2.81822 20.3542 2.34113 19.7814 2.34113Z" fill=""/>
                        <path d="M19.7814 2.96796C20.0144 2.96796 20.2085 3.1674 20.2085 3.40674V7.99969C20.2085 8.23903 20.0144 8.43847 19.7814 8.43847H14.2019C13.969 8.43847 13.7749 8.23903 13.7749 7.99969V3.40674C13.7749 3.1674 13.969 2.96796 14.2019 2.96796H19.7814ZM19.7814 1.71429H14.2019C13.2923 1.71429 12.5547 2.47219 12.5547 3.40674V7.99969C12.5547 8.93424 13.2923 9.69213 14.2019 9.69213H19.7814C20.691 9.69213 21.4286 8.93424 21.4286 7.99969V3.40674C21.4286 2.47219 20.691 1.71429 19.7814 1.71429Z" fill="#1D1D1B"/>
                        <path d="M20.824 11.4587H13.1536C12.8208 11.4587 12.5491 11.1795 12.5491 10.8318C12.5491 10.4842 12.8208 10.205 13.1536 10.205H20.824C21.1568 10.205 21.4286 10.4842 21.4286 10.8318C21.4286 11.1795 21.1568 11.4587 20.824 11.4587Z" fill="#1D1D1B"/>
                        <path d="M9.79828 13.1682H4.21878C3.64599 13.1682 3.18164 13.6453 3.18164 14.2338V18.8268C3.18164 19.4153 3.64599 19.8924 4.21878 19.8924H9.79828C10.3711 19.8924 10.8354 19.4153 10.8354 18.8268V14.2338C10.8354 13.6453 10.3711 13.1682 9.79828 13.1682Z" fill=""/>
                        <path d="M9.79826 13.795C10.0312 13.795 10.2253 13.9945 10.2253 14.2338V18.8268C10.2253 19.0661 10.0312 19.2656 9.79826 19.2656H4.21876C3.98582 19.2656 3.7917 19.0661 3.7917 18.8268V14.2338C3.7917 13.9945 3.98582 13.795 4.21876 13.795H9.79826ZM9.79826 12.5414H4.21876C3.30918 12.5414 2.57153 13.2993 2.57153 14.2338V18.8268C2.57153 19.7613 3.30918 20.5192 4.21876 20.5192H9.79826C10.7078 20.5192 11.4455 19.7613 11.4455 18.8268V14.2338C11.4455 13.2993 10.7078 12.5414 9.79826 12.5414Z" fill="#1D1D1B"/>
                        <path d="M10.8409 22.2858H3.17607C2.8433 22.2858 2.57153 22.0065 2.57153 21.6589C2.57153 21.3113 2.8433 21.0321 3.17607 21.0321H10.8465C11.1793 21.0321 11.451 21.3113 11.451 21.6589C11.451 22.0065 11.1793 22.2858 10.8465 22.2858H10.8409Z" fill="#1D1D1B"/>
                        <path d="M19.7814 13.1682H14.2019C13.6291 13.1682 13.1648 13.6453 13.1648 14.2338V18.8268C13.1648 19.4153 13.6291 19.8924 14.2019 19.8924H19.7814C20.3542 19.8924 20.8186 19.4153 20.8186 18.8268V14.2338C20.8186 13.6453 20.3542 13.1682 19.7814 13.1682Z" fill=""/>
                        <path d="M19.7814 13.795C20.0144 13.795 20.2085 13.9945 20.2085 14.2338V18.8268C20.2085 19.0661 20.0144 19.2656 19.7814 19.2656H14.2019C13.969 19.2656 13.7749 19.0661 13.7749 18.8268V14.2338C13.7749 13.9945 13.969 13.795 14.2019 13.795H19.7814ZM19.7814 12.5414H14.2019C13.2923 12.5414 12.5547 13.2993 12.5547 14.2338V18.8268C12.5547 19.7613 13.2923 20.5192 14.2019 20.5192H19.7814C20.691 20.5192 21.4286 19.7613 21.4286 18.8268V14.2338C21.4286 13.2993 20.691 12.5414 19.7814 12.5414Z" fill="#1D1D1B"/>
                        <path d="M20.824 22.2858H13.1536C12.8208 22.2858 12.5491 22.0065 12.5491 21.6589C12.5491 21.3113 12.8208 21.0321 13.1536 21.0321H20.824C21.1568 21.0321 21.4286 21.3113 21.4286 21.6589C21.4286 22.0065 21.1568 22.2858 20.824 22.2858Z" fill="#1D1D1B"/>
                        </g>
                        <defs>
                        <clipPath id="clip0_2434_305">
                        <rect width="18.8571" height="20.5714" fill="white" transform="translate(2.57153 1.71429)"/>
                        </clipPath>
                        </defs>
                      </svg>
                    </div>
                  </div>
                  <div className="api-title">로보MD 진열</div>
                  <div className="api-description">AI 기반 상품 추천 및 자동 피드 생성</div>
                  <div className="api-info">
                    <div className="info-item">
                      <div className="info-label">상태</div>
                    </div>
                    <div className="info-item right">
                      <div className="info-value">
                        {
                          this.state.rp_added_type != "Y" ? (
                            <div className="info-value inactive">미연동</div>
                          ) :
                            this.state.rp_is_finish == 1
                              ? (<div className="info-value inactive">기간 만료</div>)
                              : (<div className="info-value">연결됨</div>)
                        }
                      </div>
                    </div>
                  </div>
                  {
                    this.state.rp_added_type != "Y" ? (
                      <button className="btn-api btn-connect" onClick={() => this.goRpService()}>연결하기</button>
                    ) :
                      this.state.rp_is_finish == 1
                        ? (<button className="btn-api btn-connect" onClick={() => this.goRpService()}>연결하기</button>)
                        : (<button className="btn-api btn-connect" onClick={() => this.goRpService()}>진열 바로가기</button>)
                  }
                </div>
              </div>
            </div>
          )
      }
      </div>
    );
  }

  openConfirmDialog(props) {
    console.log("[openConfirmDialog] props:", props);
    return new Promise((resolve) => {
      const container = document.createElement("div");
      document.body.appendChild(container);

      const close = (result) => {
        resolve(result);
        ReactDOM.unmountComponentAtNode(container);
        container.remove();
      };

      ReactDOM.render(
        <TitleContentDialogV2
          {...props}
          popup_close={() => close(false)}
          button_list={[
            {
              title: "확인",
              event_method: () => close(true),
            },
            {
              title: "취소",
              event_method: () => close(false),
            },
          ]}
        />,
        container
      );
    });
  }

  render() {
    return (
      <>
        <style>
          {
            `
              .common_popup_frame_v2_content:has(.instagram-no-accounts) {
                max-width: 720px !important;
                word-break: keep-all;
              }
              .hover-underline:hover {
                text-decoration: underline;
                text-decoration-thickness: 1.5px !important;
                text-underline-offset: 3px;
                font-weight: 700;
              }

              .instagram_account_page .btn-add:active {
                  transform: scale(1) !important;
              }

              .instagram_account_page .api-icon {
                font-size: 0 !important;
              }

              .instagram_account_page .permission-limited-badge {
                display: inline-flex;
                align-items: center;
                margin-left: 8px;
                padding: 3px 8px;
                border: 1px solid #9ee7f0;
                border-radius: 999px;
                background: #f0fdff;
                color: #16869a;
                font-size: 12px;
                font-weight: 700;
                line-height: 1.4;
              }

              .instagram_account_page .permission-alert.permission-alert-limited {
                border-color: #b7e8ed !important;
                background: #f3fcfd !important;
              }

              .instagram_account_page .permission-alert.permission-alert-limited .permission-alert-text,
              .instagram_account_page .permission-alert.permission-alert-limited .permission-alert-text strong {
                color: #0A1A2F !important;
              }

              .instagram_account_page .permission-alert-info-icon {
                display: inline-flex;
                align-items: center;
                justify-content: center;
                width: 20px;
                height: 20px;
                border-radius: 50%;
                background: #35a9c9;
                color: #fff;
                font-size: 13px;
                font-weight: 800;
                font-style: normal;
                flex-shrink: 0;
              }
            `
          }
        </style>
        <div id='page-wrapper' className="container eventFormPromotion" style={{ backgroundColor: '#fafaf' }}>
          <div className="instagram_account_page">
            {this.state.isConnected ? this.renderConnected() : this.renderNotConnected()}
            {
              this.state.showFacebookDisconnectModal && (
                <div className="modal active" id="facebookDisconnectModal">
                  <div className="modal-content">
                    <div className="modal-header">
                      <h3 className="modal-title">페이스북 계정 연결을 해제하시겠습니까?</h3>
                      <p className="modal-subtitle" id="facebookModalDescription">
                        {this.state.currentfacebookAccountName} 계정의 연결을 해제합니다.
                      </p>
                    </div>

                    <div className="modal-warning">
                      <div className="warning-title">⚠️ 연결 해제 시 주의사항</div>
                      <ul className="warning-list">
                        <li>해당 페이스북 계정에 연결된 모든 인스타그램 계정이 함께 해제됩니다</li>
                        <li>자동 피드 생성 및 예약 게시물이 모두 중지됩니다</li>
                        <li>계정 통계 및 분석 데이터에 접근할 수 없습니다</li>
                        <li>다시 연결하려면 페이스북에서 재인증이 필요합니다</li>
                      </ul>
                    </div>

                    <div className="modal-footer">
                      <button className="btn btn-cancel" onClick={() => { this.closeFacebookModal() }}>취소</button>
                      <button className="btn btn-danger" onClick={() => { this.disconnectAllPermissions(this.state.currentFacebookTokenId) }}>연결 해제</button>
                    </div>
                  </div>
                </div>
              )
            }
          </div>
        </div>
        {/* 안내 문구 전달용 기본 다이얼로그 */
          (this.state.basic_dialog_show_state === true)
            ? <BasicDialogV2
              content={this.state.basic_dialog_content}
              content2={this.state.basic_dialog_content2}
              button_list={this.state.basic_dialog_button_list}
            />
            : ''
        }
        {
          /* 연결한 계정을 선택하는 팝업 */
          this.state.show_account_connect_popup && (
            <PopupFrameV2
              className={"account-connect-popup"}
              maxWidth={"950px"}
              onClose={() => this.setState({ show_account_connect_popup: false })}
            >
              <div className="instagram_account_page">
                {(this.state.add_account_list || []).length === 0 ? (
                  <>
                    <div
                      className="instagram-no-accounts instagram-connect-guide-modal"
                      style={{
                        padding: "28px 36px 32px",
                        textAlign: "center",
                        color: "var(--deep-navy, #0A1A2F)",
                        lineHeight: "1.6",
                        wordBreak: "keep-all",
                      }}
                    >
                      <div
                        style={{
                          width: "70px",
                          height: "70px",
                          margin: "0 auto 18px",
                          borderRadius: "50%",
                          background: "rgba(0, 226, 230, 0.18)",
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                        }}
                      >
                        <div
                          style={{
                            width: "52px",
                            height: "52px",
                            borderRadius: "50%",
                            background: "var(--primary-mint, #00e2e6)",
                            color: "#fff",
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            fontSize: "32px",
                            fontWeight: 900,
                            boxShadow: "0 8px 18px rgba(0, 226, 230, 0.35)",
                          }}
                        >
                          !
                        </div>
                      </div>

                      <div
                        style={{
                          color: "var(--primary-mint-hover, #00bfc2)",
                          fontSize: "17px",
                          fontWeight: 900,
                          marginBottom: "12px",
                        }}
                      >
                        인스타그램 필수가이드 확인
                      </div>

                      <div
                        style={{
                          color: "var(--deep-navy, #0A1A2F)",
                          fontSize: "26px",
                          fontWeight: 900,
                          lineHeight: "1.35",
                          letterSpacing: "-0.8px",
                        }}
                      >
                        인스타그램 규정상 <br/>
                        아래 필수 3가지 조건을 가이드를 따라 변경 후 <br/>
                        다시 계정 추가를 진행해주세요
                      </div>

                      <div
                        style={{
                          height: "1px",
                          background: "#d1d5db",
                          margin: "28px 0 22px",
                        }}
                      />

                      <div
                        style={{
                          textAlign: "left",
                          color: "var(--deep-navy, #0A1A2F)",
                          fontSize: "15px",
                          fontWeight: 700,
                          marginBottom: "16px",
                        }}
                      >
                        인스타그램 자동관리를 사용하려면 아래 3가지가 모두 필요합니다.
                      </div>

                      <div style={{ display: "flex", flexDirection: "column", gap: "10px" }}>
                        {[
                          "인스타그램 프로페셔널 계정 전환 (개인 계정 연동 불가)",
                          "페이스북 비즈니스 페이지 개설",
                          "인스타그램 계정과 페이스북 페이지 상호 연결",
                        ].map((item, index) => (
                          <div
                            key={item}
                            style={{
                              display: "flex",
                              alignItems: "center",
                              gap: "14px",
                              minHeight: "54px",
                              padding: "0 16px",
                              border: "1px solid #dfe5ec",
                              borderRadius: "8px",
                              background: "#fff",
                              color: "var(--deep-navy, #0A1A2F)",
                              fontSize: "15px",
                              fontWeight: 700,
                            }}
                          >
                            <span
                              style={{
                                width: "22px",
                                height: "22px",
                                borderRadius: "50%",
                                border: "2px solid var(--primary-mint-hover, #00bfc2)",
                                color: "var(--primary-mint-hover, #00bfc2)",
                                display: "inline-flex",
                                alignItems: "center",
                                justifyContent: "center",
                                fontSize: "13px",
                                fontWeight: 900,
                                flexShrink: 0,
                              }}
                            >
                              ✓
                            </span>
                            <span>{index + 1}. {item}</span>
                          </div>
                        ))}
                      </div>

                      <div
                        style={{
                          display: "flex",
                          gap: "12px",
                          alignItems: "flex-start",
                          marginTop: "22px",
                          padding: "16px 18px",
                          border: "1px solid #9ee7f0",
                          borderRadius: "8px",
                          background: "linear-gradient(180deg, #f0fdff 0%, #eafaff 100%)",
                          color: "var(--deep-navy, #0A1A2F)",
                          textAlign: "left",
                          fontSize: "14px",
                          fontWeight: 700,
                          lineHeight: "1.6",
                        }}
                      >
                        <span
                          style={{
                            width: "21px",
                            height: "21px",
                            borderRadius: "50%",
                            background: "#35a9c9",
                            color: "#fff",
                            display: "inline-flex",
                            alignItems: "center",
                            justifyContent: "center",
                            fontSize: "14px",
                            fontWeight: 900,
                            flexShrink: 0,
                            marginTop: "1px",
                          }}
                        >
                          i
                        </span>
                        <span>
                          위 3가지 중 하나라도 설정되지 않으면 계정 연동이 되지 않습니다.
                          <br />
                          설정 방법은 사용가이드에서 확인해주세요.
                        </span>
                      </div>

                      <div
                        style={{
                          display: "grid",
                          gridTemplateColumns: "1fr 1fr",
                          gap: "26px",
                          marginTop: "28px",
                        }}
                      >
                        <button
                          className="btn btn-primary"
                          style={{
                            height: "52px",
                            borderRadius: "10px",
                            fontSize: "15px",
                            fontWeight: 900,
                            display: "inline-flex",
                            alignItems: "center",
                            justifyContent: "center",
                            gap: "6px",
                            border: "none",
                            background: "var(--primary-mint, #00e2e6)",
                            color: "var(--deep-navy, #0A1A2F)",
                            cursor: "pointer",
                          }}
                          onClick={() => {
                            window.open(
                              "https://iclave.notion.site/Instagram-Facebook-2d363ab4c3ce800b9d58c0d0aaa0d9ce?source=copy_link",
                              "_blank"
                            );
                          }}
                        >
                          <span style={{ fontSize: "18px", lineHeight: 1 }}>↗</span>
                          가이드 바로 보기
                        </button>

                        <button
                          className="btn"
                          style={{
                            height: "52px",
                            borderRadius: "10px",
                            background: "#f1f5f9",
                            color: "#111827",
                            fontSize: "15px",
                            fontWeight: 900,
                            boxShadow: "none",
                            display: "inline-flex",
                            alignItems: "center",
                            justifyContent: "center",
                            border: "none",
                            cursor: "pointer",
                          }}
                          onClick={() => this.setState({ show_account_connect_popup: false })}
                        >
                          닫기
                        </button>
                      </div>
                    </div>
                  </>
                ) : (
                  <>
                  <h5 style={{ marginBottom: 20 }}>연결할 인스타그램 계정을 선택해주세요</h5>
                  {
                    (this.state.add_account_list || []).map((account) => (
                      <div className="instagram-accounts" key={account.token_id}>
                        {(Array.isArray(account.instagram_account_list)
                          ? account.instagram_account_list
                          : []
                        )
                          .filter((instagram) => instagram && instagram.instagram_access_token_seq)
                          .map((instagram) => (
                            <div
                              className="account-card"
                              key={instagram.instagram_access_token_seq}
                              onClick={(e) => {
                                if (e.target.closest('input[type="checkbox"], label')) return;

                                let selected_account_list = [...this.state.selected_account_list];
                                const v = String(instagram.instagram_access_token_seq);

                                if (selected_account_list.includes(v)) {
                                  selected_account_list = selected_account_list.filter(seq => seq !== v);
                                } else {
                                  selected_account_list.push(v);
                                }

                                this.setState({ selected_account_list });
                              }}
                              style={{
                                display: "flex",
                                gap: "18px",
                                cursor: "pointer",
                                userSelect: "none",
                                WebkitUserSelect: "none",
                                msUserSelect: "none",
                                WebkitUserDrag: "none",
                                WebkitTouchCallout: "none",
                              }}
                            >
                              <CheckBox
                                id={String(instagram.instagram_access_token_seq)}
                                value={String(instagram.instagram_access_token_seq)}
                                checked={this.state.selected_account_list.includes(
                                  String(instagram.instagram_access_token_seq)
                                )}
                                onChangeCheck={() => {
                                  let selected_account_list = [...this.state.selected_account_list];
                                  const v = String(instagram.instagram_access_token_seq);

                                  if (selected_account_list.includes(v)) {
                                    selected_account_list = selected_account_list.filter(seq => seq !== v);
                                  } else {
                                    selected_account_list.push(v);
                                  }

                                  this.setState({ selected_account_list });
                                }}
                              />

                              <div className="account-wrapper">
                                <div className="account-left">
                                  <div className="account-avatar">
                                    {!!instagram.profile_picture_url && (
                                      <img src={instagram.profile_picture_url} alt="" />
                                    )}
                                  </div>
                                  <div className="account-info">
                                    <div className="account-username">
                                      {instagram.username || "(username 없음)"}
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          ))}
                      </div>
                    ))
                  }
                  <div
                    style={{
                      display: "flex",
                      width: "100%",
                      justifyContent: "flex-end",
                      marginTop: "20px",
                      padding: "0 0 max(12px, env(safe-area-inset-bottom))",
                    }}
                    onPointerDown={(e) => e.stopPropagation()}
                    onTouchStart={(e) => e.stopPropagation()}
                  >
                    <button
                      type="button"
                      className="btn btn-primary"
                      style={{ minHeight: "44px", touchAction: "manipulation", transform: "scale(1)" }}
                      onClick={(e) => {
                        e.preventDefault();
                        e.stopPropagation();
                        this.updateSelectedAccountsUseYn();
                      }}
                    >
                      연결하기
                    </button>
                  </div>
                  </>
                )}
              </div>
            </PopupFrameV2>
          )
        }
        {
          /* 인스타그램 계정 연결 전달용 기본 다이얼로그 */
          (this.state.warning_dialog_show_state === true)
            ? <WarningDialog
              content={this.state.warning_dialog_content}
                button_list={[{
                    title : "확인",
                    event_method : () => { this.setState({warning_dialog_show_state : false}) }
                }]}
                popup_close={() => {this.setState({warning_dialog_show_state : false})}}
            />
            : ''
        }
      </>
    )
  }
}